import moment from "moment-timezone";

export function formatSize(bytes) {
  if (bytes === undefined || bytes === null) return '';
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(i ? 1 : 0)} ${sizes[i]}`;
}

export const formatDate = (date) => {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const d = date instanceof Date ? date : new Date(date);
  const offset = d.getTimezoneOffset();
  const date_with_timezone = new Date(d.getTime() - (offset * 60 * 1000));
  return moment(date_with_timezone).tz(zone).format('MM-DD-yyyy HH:mm');
};

export function formatBuckets(buckets) {
  if (!buckets || !Array.isArray(buckets)) return [];
  return buckets.map(b => ({
    id: b.name,
    name: b.name,
    creation_date: formatDate(b.creation_date),
  }));
}

export function formatBucketFolderItems(data, bucketName, searchItems = false) {
  if (!data) return [];
  const files = Array.isArray(data.files)
    ? data.files.map(file => ({
      id: `${bucketName}/${file.key}`,
      name: searchItems ? file.key : file.key.split('/').pop(),
      type: file.key.split('.').pop(),
      size: file.size !== undefined ? typeof file.size === 'number' ? formatSize(file.size) : file.size : '',
      last_modified: file.lastModified ? formatDate(file.lastModified) : '',
      isFolder: false,
    }))
    : [];
  const folders = Array.isArray(data.folders)
    ? data.folders.map(folder => ({
      id: `${bucketName}/${folder}`,
      name: searchItems ? folder : folder.split('/').filter(Boolean).pop(),
      path: folder,
      type: 'folder',
      size: '-',
      last_modified: '-',
      isFolder: true,
    }))
    : [];
  return [...folders, ...files];
}


export function getErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const status = error?.response?.status;
  const apiMsg =
    error?.response?.data?.message ||
    error?.response?.data?.detail ||
    error?.response?.data?.error;
  if (status === 404) return "Token not found. It might have been deleted by another user.";
  if (status === 400) return apiMsg || "Bad request. Please check your input.";
  if (status === 401) return "Unauthorized. Please login again.";
  if (status === 403) return "Forbidden. You don't have permission to perform this action.";
  if (status === 409) return apiMsg || "Conflict. The record may have been updated by someone else.";
  if (status >= 500) return "Server error. Please try again later.";

  if (error?.message === "Network Error") return "Network error. Please check your connection.";
  return apiMsg || error?.message || fallback;
}


export function formatAllValidTokens(records) {
  if (!records) return [];
  return records.map(rec => ({
    id: rec.id,
    name: rec.name,
    desc: rec.desc,
    expires_at: rec.expires_at ? formatDate(rec.expires_at) : '-',
    created_by: rec.created_by,
    created_at: rec.created_at ? formatDate(rec.created_at) : '-',
    last_used_at: rec.last_used_at ? formatDate(rec.last_used_at) : '-',
    token_prefix: rec.token_prefix,
    status: rec.status,
    rotated_by: rec.rotated_by,
    rotated_at: rec.rotated_at ? formatDate(rec.rotated_at) : '-',
    revoked_by: rec.revoked_by,
    revoked_at: rec.revoked_at ? formatDate(rec.revoked_at) : '-',
    revoke_reason: rec.revoke_reason,
  }));
}
